import { render, staticRenderFns } from "./RssFeeds.vue?vue&type=template&id=d674f3aa&scoped=true&"
import script from "./RssFeeds.vue?vue&type=script&lang=js&"
export * from "./RssFeeds.vue?vue&type=script&lang=js&"
import style0 from "./RssFeeds.vue?vue&type=style&index=0&id=d674f3aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d674f3aa",
  null
  
)

export default component.exports